export default "__VITE_ASSET__DDHIfkyl__"